export const ACCESS_TOKEN = 'Access-Token'
export const USER_INFO = 'User-info'
export const SID = 'SID'
export const TID = 'TID'

export const HOME_PAGE = '/dashboard/putuo' // 首页路由
